const Resources = {

    table_headers: [
        {
            text:   'Walking#',
            value:  'walking_number',
            report_value: 'walking_number',
            type:   'link',
            show: true,
            order: 0,

        },
        { 
            text:   'Description',
            value:  'description',
            report_value: 'unique_id',
            type:   'link',
            with_icon: true,
            src_icon: '/assets/img/svg/customdescriptionicon.svg',
            show: true,
            order: 1,
        },
        { 
            text:   'Fixture/Beds',
            value:  'fixture_number',
        },
        { 
            text:   'Minutes',
            value:  'daily_minutes',
            report_value: 'daily_tasks_minutes',
            show: true,
            order: 2,
        },
        { 
            text:   'Sq.Feet',
            value:  'sq_ft',
            report_value: 'sq_ft',
            show: true,
            order: 3,
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type: 'tasks',
            report_value: 'all_daily_tasks',
            show: true,
            order: 4,
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
            report_value: 'all_policing_tasks',
            show: true,
            order: 5,
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_tasks',
            report_value: 'all_project_tasks',
            type:   'tasks',
            class:  'header-orange',
            show: true,
            order: 6,
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms',
            href:   '/building-rooms',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms - Advanced search',
            href:   '/building-rooms-advanced-search',
            arrow:  "",
        },
    ],

    radio_options: [
        {
            div_class: 'p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'daily',
            name: 'Daily',
            model: 'daily',
        },
        {
            div_class: 'p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'projects',
            name: 'Project',
            model: 'projects',
        },
        {
            div_class: 'p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'policing',
            name: 'Policing',
            model: 'policing',
        },
        {
            div_class: 'p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'all',
            name: 'None',
            model: 'all',
        },
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    simbol_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

    shift_criteria_options:[
        {
            id:     1,
            name:   'All selected shifts',
        },
        {
            id:     2,
            name:   'Any selected shifts',
        },
    ],

}

export default Resources